import { IFrameHtmlBuilderOptions } from "@fanfanlo";

function createHtml(script: string, opts?:IFrameHtmlBuilderOptions) {
    return `<html>
    <head>
    <script type="importmap">
  {
    "imports": {
      "react": "https://esm.sh/react@19",
      "react-dom/client": "https://esm.sh/react-dom@19/client"
    }
  }
</script>
        <script>
                const IFRAME_ID = '${opts?.iframeId}';
                window.IFRAME_ID = '${opts?.iframeId}';
                
            var autoWebViewJs = window.autoWebViewJs = window.parent.window.autoWebViewJs;
            autoWebViewJs = window.parent.window.autoWebViewJs;
            var callScript = window.callScript = autoWebViewJs.callScript;
            var callScriptByConf = window.callScriptByConf = autoWebViewJs.callScriptByConf;
            var isRealInAndroid = window.isRealInAndroid;
            // var storeUtilsConf = window.storeUtilsConf = window.parent.window.storeUtilsConf;
            var storeUtilsConf = window.storeUtilsConf = {
                ns:{},
                read:window.parent.window.storeUtilsConf.read,
                write:window.parent.window.storeUtilsConf.write   
            }
        </script>
        <title>droid lego</title>
        <style>html, body{margin-left:-0px;padding:0;
        background-color: white;}</style>
    </head>
    <body>
        <div id="app"></div>
        <script>${script}</script>
        <script>
                // const IFRAME_ID = '${opts?.iframeId}';
                function notifyResize() {
                    const body = document.body;
                    const html = document.documentElement;
                    
                    // 获取实际内容高度（取最大值）
                    const height = Math.max(
                        body.scrollHeight,
                        body.offsetHeight,
                        html.scrollHeight,
                        html.offsetHeight
                    );
                    
                    // 获取实际内容宽度
                    const width = Math.max(
                        body.scrollWidth,
                        body.offsetWidth,
                        html.scrollWidth,
                        html.offsetWidth
                    );
                    
                    // 发送消息给父窗口
                    window.parent.postMessage({
                        type: 'resize',
                        iframeId: IFRAME_ID,
                        height,
                        width
                    }, '*');
                }
                
                // 监听窗口大小变化
                window.addEventListener('resize', notifyResize);
                
                // 监听DOMContentLoaded，确保DOM加载完毕后调整大小
                document.addEventListener('DOMContentLoaded', notifyResize);
                
                // 监听load事件，确保所有资源加载完毕后调整大小
                window.addEventListener('load', notifyResize);
                
                // 创建MutationObserver监听DOM变化
                const observer = new MutationObserver(notifyResize);
                observer.observe(document.documentElement, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    characterData: true
                });
                
                // 监听来自父窗口的消息，处理请求重新调整大小的消息
                window.addEventListener('message', function(event) {
                    if (event.data && event.data.type === 'requestResize') {
                        // 主动触发一次尺寸计算和发送
                        notifyResize();
                    }
                });
                
                // 初始化大小
                notifyResize();
        </script>
    </body>
</html>`
}

function mergeHtml(html:string, opts?:IFrameHtmlBuilderOptions){
    let h = html;
    if(!h.includes('<body')){
        h = `<body>${h}</body>`
    }
    if(!h.includes('<html')){
        h = `<html>${h}</html>`
    }
    if(!h.includes('<head')){
        h = h.replace('<html>', '<html><head></head>')
    }
    h = h.replace('<head>', `<head><script>
                const IFRAME_ID = '${opts?.iframeId}';
                window.IFRAME_ID = '${opts?.iframeId}';
                
            var autoWebViewJs = window.autoWebViewJs = window.parent.window.autoWebViewJs;
            autoWebViewJs = window.parent.window.autoWebViewJs;
            var callScript = window.callScript = autoWebViewJs.callScript;
            var callScriptByConf = window.callScriptByConf = autoWebViewJs.callScriptByConf;
            var isRealInAndroid = window.isRealInAndroid;
            // var storeUtilsConf = window.storeUtilsConf = window.parent.window.storeUtilsConf;
            var storeUtilsConf = window.storeUtilsConf = {
                ns:{},
                read:window.parent.window.storeUtilsConf.read,
                write:window.parent.window.storeUtilsConf.write   
            }
        </script>
        
        <style>html, body{margin-left:-0px;padding:0;
        background-color: white;}</style>`);

    h = h.replace(`</body>`, `
        
        <script>
                function notifyResize() {
                    const body = document.body;
                    const html = document.documentElement;
                    
                    // 获取实际内容高度（取最大值）
                    const height = Math.max(
                        body.scrollHeight,
                        body.offsetHeight,
                        html.scrollHeight,
                        html.offsetHeight
                    );
                    
                    // 获取实际内容宽度
                    const width = Math.max(
                        body.scrollWidth,
                        body.offsetWidth,
                        html.scrollWidth,
                        html.offsetWidth
                    );
                    
                    // 发送消息给父窗口
                    window.parent.postMessage({
                        type: 'resize',
                        iframeId: IFRAME_ID,
                        height,
                        width
                    }, '*');
                }
                
                // 监听窗口大小变化
                window.addEventListener('resize', notifyResize);
                
                // 监听DOMContentLoaded，确保DOM加载完毕后调整大小
                document.addEventListener('DOMContentLoaded', notifyResize);
                
                // 监听load事件，确保所有资源加载完毕后调整大小
                window.addEventListener('load', notifyResize);
                
                // 创建MutationObserver监听DOM变化
                const observer = new MutationObserver(notifyResize);
                observer.observe(document.documentElement, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    characterData: true
                });
                
                // 监听来自父窗口的消息，处理请求重新调整大小的消息
                window.addEventListener('message', function(event) {
                    if (event.data && event.data.type === 'requestResize') {
                        // 主动触发一次尺寸计算和发送
                        notifyResize();
                    }
                });
                
                // 初始化大小
                notifyResize();
        </script>
        </body>`);
        console.log('hhhhhhhhhhhhh=', h);
    return h;
}
async function createHtmlByUrl(url: string, opts?:IFrameHtmlBuilderOptions) {
    const res = await fetch(url);
    const content = await res.text();
    return createHtml(content, opts);
}
export const marketHtmlUtils = {
    createHtml,
    createHtmlByUrl,
    mergeHtml
}